<template>
  <div class="slider">
    <div class="button pre" @click="changeIndex(-1)"></div>
    <div class="slider_area">
      <img
        :src="require('../assets/imgs/' + item)"
        alt=""
        v-for="(item, index) of list"
        :key="index"
        :class="[
          index === activeIndex
            ? 'active'
            : (index + 1) % list.length === activeIndex
            ? 'pre'
            : (activeIndex + 1) % list.length === index
            ? 'next'
            : '',
        ]"
      />
    </div>
    <div class="button next" @click="changeIndex(1)"></div>
  </div>
</template>

<script lang="ts">
import { ref } from "@vue/runtime-core";

export default {
  name: "slider",
  props: {
    data: {
      // 菜单数据
      type: Array,
      required: true,
      default() {
        return [];
      },
    },
  },
  setup(props: any) {
    const list: any = ref([]);
    props.data.forEach((item: any) => {
      list.value.push(item);
    });
    const activeIndex: any = ref(0);
    const changeIndex = (num: number) => {
      activeIndex.value =
        (activeIndex.value + num + list.value.length) % list.value.length;
    };
    return {
      list,
      activeIndex,
      changeIndex,
    };
  },
};
</script>
<style scoped lang="less">
.slider {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .button {
    height: 48px;
    line-height: 44px;
    width: 48px;
    text-align: center;
    background: #fff;
    color: #000;
    box-shadow: 0 0 10px 1px #e6ebed;
    border-radius: 3px;
    cursor: pointer;
    font-size: 18px;
    font-weight: bold;
    transition: 0.5s all;
    &:hover {
      color: #fff;
      background: #437acf;
    }
    &.pre::before {
      content: "<";
      display: inline-block;
      transform: scale(1, 1.8);
    }
    &.next::before {
      content: ">";
      display: inline-block;
      transform: scale(1, 1.8);
    }
  }
  .slider_area {
    width: 1020px;
    height: 428px;
    position: relative;
    img {
      position: absolute;
      width: 446px;
      top: 72px;
      left: 287px;
      opacity: 0;
      border-radius: 8px;
      box-shadow: 0 0 10px 1px #e6ebed;
      transition: 0.5s all;
      &.pre {
        left: 0;
        opacity: 0.8;
      }
      &.next {
        left: 574px;
        opacity: 0.8;
      }
      &.active {
        width: 668px;
        left: 176px;
        top: 0;
        opacity: 1;
        z-index: 1;
      }
    }
  }
}
</style>
